module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-3.48b93011.jpg";